<!-- Generated by GitHub Copilot - Oct-12-2026 -->
<div class="ms-root">
  <button
    type="button"
    class="ms-toggle"
    [id]="inputId()"
    aria-haspopup="true"
    [attr.aria-expanded]="open"
    [attr.aria-controls]="inputId() + '-panel'"
    [title]="summary"
    (click)="toggle()">
    <span class="ms-label">{{ summary }}</span>
  </button>

  @if (open) {
  <div class="ms-panel" role="group" [id]="inputId() + '-panel'" [attr.aria-label]="label()">
    <label class="ms-item">
      <input type="checkbox" [checked]="allSelected" (change)="toggleAll()" />
      <span>{{ allLabel() }}</span>
    </label>
    @for (option of options(); track option) {
    <label class="ms-item">
      <input type="checkbox" [checked]="isSelected(option)" (change)="toggleOption(option)" />
      <span>{{ option }}</span>
    </label>
    } @empty {
    <div class="ms-empty">No options available</div>
    }
  </div>
  }
</div>
